import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AppVersion } from '../consts/app-version.const';
import { TranslationService } from '../services/translation.service';
import { PLATFORM_TOKEN, PlatformProvider } from '../tokens/platform.token';
import { ENV_CONFIG, EnvConfig } from './env-config.token';

const LANGUAGE_HEADER: string = 'X-User-Language';
const TIMEZONE_HEADER: string = 'X-User-Timezone';
const APP_VERSION_HEADER: string = 'X-App-Version';
const PLATFORM_HEADER: string = 'X-Platform';

export const userContextHeadersInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const env: EnvConfig = inject(ENV_CONFIG);
  if (!req.url.startsWith(env.apiUrl)) {
    return next(req);
  }

  const translation: TranslationService = inject(TranslationService);
  const platform: PlatformProvider = inject(PLATFORM_TOKEN);
  const language: string = translation.currentLanguage();
  const timezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const headers: Record<string, string> = {
    [LANGUAGE_HEADER]: language,
    [APP_VERSION_HEADER]: AppVersion,
    [PLATFORM_HEADER]: platform.platformType
  };
  if (timezone) {
    headers[TIMEZONE_HEADER] = timezone;
  }
  return next(req.clone({ setHeaders: headers }));
};
